import React from 'react';
import { SpaceContext } from "./Space";
import { prefix } from "./style";

function Item(props) {
  var children = props.children,
      className = props.className,
      index = props.index,
      split = props.split;

  var _React$useContext = React.useContext(SpaceContext),
      lastIndex = _React$useContext.lastIndex;

  if (children === null || children === undefined) {
    return null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: className
  }, children), index < lastIndex && split && /*#__PURE__*/React.createElement("span", {
    className: prefix('-split')()
  }, split));
}

export default Item;